export interface Artista {
  id: string;
  nome: string;
  imagem: string;
  descricao: string;
  albuns: number;
  musicas: number;
  genero: string;
}

export const artistas: Artista[] = [
  {
    id: "fernandinho",
    nome: "Fernandinho",
    imagem: "https://readdy.ai/api/search-image?query=Fernandinho%20gospel%20singer%20brazilian%20male%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-fernandinho&orientation=squarish",
    descricao: "Um dos maiores nomes do gospel brasileiro, conhecido por hits como 'Galileu' e 'Uma Nova História'.",
    albuns: 12,
    musicas: 156,
    genero: "Gospel/Adoração",
  },
  {
    id: "andre-valadao",
    nome: "André Valadão",
    imagem: "https://readdy.ai/api/search-image?query=Andre%20Valadao%20gospel%20brazilian%20musician%20male%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-andre&orientation=squarish",
    descricao: "Líder de adoração e pastor, referência no movimento gospel brasileiro com canções poderosas.",
    albuns: 15,
    musicas: 210,
    genero: "Gospel/Adoração",
  },
  {
    id: "ana-paula-valadao",
    nome: "Ana Paula Valadão",
    imagem: "https://readdy.ai/api/search-image?query=Ana%20Paula%20Valadao%20brazilian%20gospel%20singer%20female%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-ana&orientation=squarish",
    descricao: "Fundadora do Ministério Diante do Trono, uma das maiores referências do gospel nacional e internacional.",
    albuns: 25,
    musicas: 340,
    genero: "Gospel/Adoração",
  },
  {
    id: "aline-barros",
    nome: "Aline Barros",
    imagem: "https://readdy.ai/api/search-image?query=Aline%20Barros%20brazilian%20gospel%20singer%20female%20professional%20portrait%20concert%20stage%20golden%20lighting&width=400&height=400&seq=godoy-aline&orientation=squarish",
    descricao: "Cantora gospel premiada com Grammy Latino, conhecida por 'Ressuscita-me' e 'Consagrado'.",
    albuns: 18,
    musicas: 245,
    genero: "Gospel/Adoração",
  },
  {
    id: "eli-soares",
    nome: "Eli Soares",
    imagem: "https://readdy.ai/api/search-image?query=Eli%20Soares%20brazilian%20male%20gospel%20singer%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-eli&orientation=squarish",
    descricao: "Cantor e compositor gospel, conhecido por sua voz marcante e canções de adoração profunda.",
    albuns: 8,
    musicas: 98,
    genero: "Gospel/Adoração",
  },
  {
    id: "gabriela-rocha",
    nome: "Gabriela Rocha",
    imagem: "https://readdy.ai/api/search-image?query=Gabriela%20Rocha%20young%20brazilian%20female%20gospel%20singer%20professional%20portrait%20stage%20performance%20dramatic%20lighting&width=400&height=400&seq=godoy-gabriela&orientation=squarish",
    descricao: "Cantora gospel que conquistou milhões com 'Lugar Secreto', referência da nova geração gospel.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "ton-carfi",
    nome: "Ton Carfi",
    imagem: "https://readdy.ai/api/search-image?query=Ton%20Carfi%20brazilian%20gospel%20male%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-ton&orientation=squarish",
    descricao: "Líder do grupo Trazendo a Arca, um dos pioneiros do gospel contemporâneo brasileiro.",
    albuns: 10,
    musicas: 134,
    genero: "Gospel/Adoração",
  },
  {
    id: "kleber-lucas",
    nome: "Kleber Lucas",
    imagem: "https://readdy.ai/api/search-image?query=Kleber%20Lucas%20brazilian%20male%20gospel%20singer%20professional%20portrait%20stage%20performance%20warm%20lighting&width=400&height=400&seq=godoy-kleber&orientation=squarish",
    descricao: "Cantor e compositor gospel, autor de clássicos como 'Deus Cuida de Mim' e 'Aos Pés da Cruz'.",
    albuns: 11,
    musicas: 142,
    genero: "Gospel/Adoração",
  },
  {
    id: "isaias-saad",
    nome: "Isaías Saad",
    imagem: "https://readdy.ai/api/search-image?query=Isaias%20Saad%20brazilian%20male%20gospel%20singer%20young%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-isaias&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel, integrante do Preto no Branco.",
    albuns: 5,
    musicas: 58,
    genero: "Gospel/Adoração",
  },
  {
    id: "preto-no-branco",
    nome: "Preto no Branco",
    imagem: "https://readdy.ai/api/search-image?query=Preto%20no%20Branco%20gospel%20music%20band%20group%20brazilian%20performers%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-pnb&orientation=squarish",
    descricao: "Coletivo de artistas gospel que reúne grandes nomes da música cristã contemporânea.",
    albuns: 6,
    musicas: 68,
    genero: "Gospel/Adoração",
  },
  {
    id: "davi-sacer",
    nome: "Davi Sacer",
    imagem: "https://readdy.ai/api/search-image?query=Davi%20Sacer%20brazilian%20male%20gospel%20singer%20professional%20portrait%20warm%20lighting%20dark%20background&width=400&height=400&seq=godoy-davi&orientation=squarish",
    descricao: "Ex-integrante do Trazendo a Arca, conhecido por canções como 'Deus Não Falhará'.",
    albuns: 7,
    musicas: 86,
    genero: "Gospel/Adoração",
  },
  {
    id: "lukas-agustinho",
    nome: "Lukas Agustinho",
    imagem: "https://readdy.ai/api/search-image?query=Lukas%20Agustinho%20brazilian%20male%20gospel%20singer%20young%20professional%20portrait%20stage%20performance&width=400&height=400&seq=godoy-lukas&orientation=squarish",
    descricao: "Cantor gospel que leva uma mensagem de fé e esperança através de canções inspiradoras.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "anderson-freire",
    nome: "Anderson Freire",
    imagem: "https://readdy.ai/api/search-image?query=Anderson%20Freire%20brazilian%20male%20gospel%20singer%20songwriter%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-anderson&orientation=squarish",
    descricao: "Cantor e compositor de grandes clássicos do gospel como 'Raridade' e 'Acalha o Meu Coração'.",
    albuns: 9,
    musicas: 112,
    genero: "Gospel/Adoração",
  },
  {
    id: "fernanda-brum",
    nome: "Fernanda Brum",
    imagem: "https://readdy.ai/api/search-image?query=Fernanda%20Brum%20brazilian%20female%20gospel%20singer%20professional%20portrait%20concert%20stage%20golden%20lighting&width=400&height=400&seq=godoy-fernanda&orientation=squarish",
    descricao: "Cantora gospel premiada com Grammy Latino, voz marcante no cenário cristão nacional.",
    albuns: 14,
    musicas: 178,
    genero: "Gospel/Adoração",
  },
  {
    id: "bruna-karla",
    nome: "Bruna Karla",
    imagem: "https://readdy.ai/api/search-image?query=Bruna%20Karla%20brazilian%20female%20gospel%20singer%20professional%20portrait%20dramatic%20lighting%20dark%20background&width=400&height=400&seq=godoy-bruna&orientation=squarish",
    descricao: "Cantora gospel conhecida por hits como 'Sou Humano' e 'Quando Eu Chorar'.",
    albuns: 10,
    musicas: 125,
    genero: "Gospel/Adoração",
  },
  {
    id: "nivea-soares",
    nome: "Nívea Soares",
    imagem: "https://readdy.ai/api/search-image?query=Nivea%20Soares%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20stage%20lighting&width=400&height=400&seq=godoy-nivea&orientation=squarish",
    descricao: "Líder de adoração e cantora gospel com mais de 20 anos de ministério.",
    albuns: 13,
    musicas: 168,
    genero: "Gospel/Adoração",
  },
  {
    id: "rosa-de-saron",
    nome: "Rosa de Saron",
    imagem: "https://readdy.ai/api/search-image?query=Rosa%20de%20Saron%20christian%20rock%20band%20brazilian%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-rosa&orientation=squarish",
    descricao: "Banda de rock cristão brasileira com mais de 30 anos de carreira e álbuns icônicos.",
    albuns: 16,
    musicas: 198,
    genero: "Rock Gospel",
  },
  {
    id: "oficina-g3",
    nome: "Oficina G3",
    imagem: "https://readdy.ai/api/search-image?query=Oficina%20G3%20christian%20rock%20band%20brazilian%20guitar%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-oficina&orientation=squarish",
    descricao: "Pioneiros do rock cristão no Brasil, com influência do hard rock e metal cristão.",
    albuns: 14,
    musicas: 172,
    genero: "Rock Gospel",
  },
  {
    id: "cristina-mel",
    nome: "Cristina Mel",
    imagem: "https://readdy.ai/api/search-image?query=Cristina%20Mel%20brazilian%20female%20gospel%20singer%20professional%20portrait%20warm%20lighting%20stage&width=400&height=400&seq=godoy-cristina&orientation=squarish",
    descricao: "Cantora gospel e apresentadora, uma das vozes mais conhecidas do gospel feminino.",
    albuns: 20,
    musicas: 256,
    genero: "Gospel/Adoração",
  },
  {
    id: "cassiane",
    nome: "Cassiane",
    imagem: "https://readdy.ai/api/search-image?query=Cassiane%20brazilian%20female%20gospel%20singer%20veteran%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-cassiane&orientation=squarish",
    descricao: "Uma das pioneiras do gospel brasileiro, com carreira de mais de 40 anos e clássicos atemporais.",
    albuns: 24,
    musicas: 312,
    genero: "Gospel/Adoração",
  },
  {
    id: "ludmila-ferber",
    nome: "Ludmila Ferber",
    imagem: "https://readdy.ai/api/search-image?query=Ludmila%20Ferber%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-ludmila&orientation=squarish",
    descricao: "Cantora e pastora com uma das vozes mais potentes do gospel nacional, autora de 'Deus é Fiel'.",
    albuns: 12,
    musicas: 145,
    genero: "Gospel/Adoração",
  },
  {
    id: "grupo-logos",
    nome: "Grupo Logos",
    imagem: "https://readdy.ai/api/search-image?query=Grupo%20Logos%20brazilian%20gospel%20music%20group%20band%20performance%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-logos&orientation=squarish",
    descricao: "Banda gospel brasileira com tradição no pop rock cristão, marcando gerações desde os anos 90.",
    albuns: 10,
    musicas: 118,
    genero: "Pop Rock Gospel",
  },
  {
    id: "thalles-roberto",
    nome: "Thalles Roberto",
    imagem: "https://readdy.ai/api/search-image?query=Thalles%20Roberto%20brazilian%20male%20gospel%20singer%20songwriter%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-thalles&orientation=squarish",
    descricao: "Cantor e compositor de sucessos como 'Filho Meu' e 'Deus da Minha Vida', com forte presença digital.",
    albuns: 9,
    musicas: 102,
    genero: "Gospel/Adoração",
  },
  {
    id: "sarah-ferreira",
    nome: "Sarah Ferreira",
    imagem: "https://readdy.ai/api/search-image?query=Sarah%20Ferreira%20brazilian%20female%20gospel%20singer%20young%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-sarah&orientation=squarish",
    descricao: "Voz da nova geração gospel brasileira, conhecida por canções de adoração profunda e intimista.",
    albuns: 4,
    musicas: 46,
    genero: "Gospel/Adoração",
  },
  {
    id: "soraya-moraes",
    nome: "Soraya Moraes",
    imagem: "https://readdy.ai/api/search-image?query=Soraya%20Moraes%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20golden%20lighting&width=400&height=400&seq=godoy-soraya&orientation=squarish",
    descricao: "Cantora gospel com mais de 25 anos de carreira, referência em adoração e voz marcante.",
    albuns: 15,
    musicas: 185,
    genero: "Gospel/Adoração",
  },
  {
    id: "marquinhos-gomes",
    nome: "Marquinhos Gomes",
    imagem: "https://readdy.ai/api/search-image?query=Marquinhos%20Gomes%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-marquinhos&orientation=squarish",
    descricao: "Cantor e compositor de clássicos como 'Marca da Promessa' e 'Rei de Amor', com mais de 20 anos de ministério.",
    albuns: 11,
    musicas: 132,
    genero: "Gospel/Adoração",
  },
  {
    id: "rodolfo-abrantes",
    nome: "Rodolfo Abrantes",
    imagem: "https://readdy.ai/api/search-image?query=Rodolfo%20Abrantes%20brazilian%20male%20gospel%20rock%20singer%20guitarist%20professional%20portrait%20stage%20lighting%20dark%20background&width=400&height=400&seq=godoy-rodolfo&orientation=squarish",
    descricao: "Ex-vocalista do Raimundos, converteu-se e tornou-se referência no rock gospel brasileiro com projetos solo.",
    albuns: 6,
    musicas: 72,
    genero: "Rock Gospel",
  },
  {
    id: "morada",
    nome: "Morada",
    imagem: "https://readdy.ai/api/search-image?query=Morada%20brazilian%20gospel%20worship%20band%20group%20performance%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-morada&orientation=squarish",
    descricao: "Ministério de adoração que surgiu na Igreja Batista de Lagoinha, conhecido por 'Pai Nosso' e 'O Mover do Espírito'.",
    albuns: 8,
    musicas: 94,
    genero: "Gospel/Adoração",
  },
  {
    id: "ministerio-novo-tempo",
    nome: "Ministério Novo Tempo",
    imagem: "https://readdy.ai/api/search-image?query=Ministerio%20Novo%20Tempo%20brazilian%20gospel%20worship%20choir%20group%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-novotempo&orientation=squarish",
    descricao: "Ministério de louvor com canções que viraram hinos em igrejas por todo o Brasil.",
    albuns: 7,
    musicas: 84,
    genero: "Gospel/Adoração",
  },
  {
    id: "lagoinha-music",
    nome: "Lagoinha Music",
    imagem: "https://readdy.ai/api/search-image?query=Lagoinha%20Music%20brazilian%20gospel%20worship%20band%20group%20performance%20concert%20stage%20professional%20photo&width=400&height=400&seq=godoy-lagoinha&orientation=squarish",
    descricao: "Ministério de música da Igreja Batista da Lagoinha, berço de grandes adoradores do Brasil.",
    albuns: 10,
    musicas: 120,
    genero: "Gospel/Adoração",
  },
  {
    id: "jotta-a",
    nome: "Jotta A",
    imagem: "https://readdy.ai/api/search-image?query=Jotta%20A%20brazilian%20male%20gospel%20singer%20young%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-jotta&orientation=squarish",
    descricao: "Cantor gospel que viralizou mundialmente com 'Agnus Dei' ainda criança, hoje com carreira consolidada.",
    albuns: 5,
    musicas: 56,
    genero: "Gospel/Adoração",
  },
  {
    id: "daniela-araujo",
    nome: "Daniela Araújo",
    imagem: "https://readdy.ai/api/search-image?query=Daniela%20Araujo%20brazilian%20female%20gospel%20singer%20professional%20portrait%20warm%20lighting%20dark%20background&width=400&height=400&seq=godoy-daniela&orientation=squarish",
    descricao: "Cantora e compositora gospel com hits como 'Nada Além da Graça' e 'Confiar em Ti'.",
    albuns: 6,
    musicas: 68,
    genero: "Gospel/Adoração",
  },
  {
    id: "ivo-mozart",
    nome: "Ivo Mozart",
    imagem: "https://readdy.ai/api/search-image?query=Ivo%20Mozart%20brazilian%20male%20gospel%20singer%20songwriter%20acoustic%20guitar%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-ivo&orientation=squarish",
    descricao: "Cantor e compositor com estilo único que mistura pop, folk e espiritualidade em canções como 'Tocando em Frente'.",
    albuns: 7,
    musicas: 78,
    genero: "Pop Gospel",
  },
  {
    id: "carlinhos-felix",
    nome: "Carlinhos Félix",
    imagem: "https://readdy.ai/api/search-image?query=Carlinhos%20Felix%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-carlinhos&orientation=squarish",
    descricao: "Cantor gospel conhecido por 'O Amigo' e 'Razão de Viver', com carreira de mais de 25 anos.",
    albuns: 14,
    musicas: 168,
    genero: "Gospel/Adoração",
  },
  {
    id: "sarah-sheeva",
    nome: "Sarah Sheeva",
    imagem: "https://readdy.ai/api/search-image?query=Sarah%20Sheeva%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-sheeva&orientation=squarish",
    descricao: "Cantora e pastora com canções proféticas e de adoração, marcou época com hits poderosos.",
    albuns: 10,
    musicas: 115,
    genero: "Gospel/Adoração",
  },
  {
    id: "damares",
    nome: "Damares",
    imagem: "https://readdy.ai/api/search-image?query=Damares%20brazilian%20female%20gospel%20singer%20professional%20portrait%20concert%20stage%20golden%20lighting&width=400&height=400&seq=godoy-damares&orientation=squarish",
    descricao: "Cantora gospel conhecida como a 'Diva da Adoração', com hits como 'Sabor de Mel' e 'Diário de um Vencedor'.",
    albuns: 16,
    musicas: 195,
    genero: "Gospel/Adoração",
  },
  {
    id: "regis-danese",
    nome: "Regis Danese",
    imagem: "https://readdy.ai/api/search-image?query=Regis%20Danese%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-regis&orientation=squarish",
    descricao: "Cantor gospel com mais de 20 anos de carreira e hits como 'Creio em Ti' e 'Companheiro'.",
    albuns: 12,
    musicas: 138,
    genero: "Gospel/Adoração",
  },
  {
    id: "arquivo-vivo",
    nome: "Arquivo Vivo",
    imagem: "https://readdy.ai/api/search-image?query=Arquivo%20Vivo%20brazilian%20gospel%20rock%20band%20group%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-arquivovivo&orientation=squarish",
    descricao: "Banda de rock gospel com sons modernos e letras profundas, representando a nova geração cristã.",
    albuns: 3,
    musicas: 34,
    genero: "Rock Gospel",
  },
  {
    id: "pregador-luo",
    nome: "Pregador Luo",
    imagem: "https://readdy.ai/api/search-image?query=Pregador%20Luo%20brazilian%20male%20gospel%20rapper%20hip%20hop%20artist%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-luo&orientation=squarish",
    descricao: "Pioneiro do gospel rap no Brasil, referência no hip hop cristão com letras impactantes.",
    albuns: 8,
    musicas: 96,
    genero: "Gospel Rap",
  },
  {
    id: "marcela-gandara",
    nome: "Marcela Gandara",
    imagem: "https://readdy.ai/api/search-image?query=Marcela%20Gandara%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-marcela&orientation=squarish",
    descricao: "Cantora gospel com clássicos como 'Supe que Tengo Que', referência da adoração em espanhol no Brasil.",
    albuns: 9,
    musicas: 108,
    genero: "Gospel/Adoração",
  },
  {
    id: "fernando-adriano",
    nome: "Fernando Adriano",
    imagem: "https://readdy.ai/api/search-image?query=Fernando%20Adriano%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-fernandoadriano&orientation=squarish",
    descricao: "Cantor e compositor com hits de adoração que marcaram igrejas em todo o país.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "eyshila",
    nome: "Eyshila",
    imagem: "https://readdy.ai/api/search-image?query=Eyshila%20brazilian%20female%20gospel%20singer%20professional%20portrait%20concert%20stage%20dramatic%20lighting&width=400&height=400&seq=godoy-eyshila&orientation=squarish",
    descricao: "Cantora gospel conhecida como 'Princesa da Adoração', com hits como 'O Inimigo Caiu' e 'Eu Acredito'.",
    albuns: 13,
    musicas: 158,
    genero: "Gospel/Adoração",
  },
  {
    id: "jonas-esticado",
    nome: "Jonas Esticado",
    imagem: "https://readdy.ai/api/search-image?query=Jonas%20Esticado%20brazilian%20male%20gospel%20singer%20young%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-jonas&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel, com canções que misturam adoração e pop contemporâneo.",
    albuns: 4,
    musicas: 45,
    genero: "Pop Gospel",
  },
  {
    id: "rede-atitude",
    nome: "Rede Atitude",
    imagem: "https://readdy.ai/api/search-image?query=Rede%20Atitude%20brazilian%20gospel%20band%20group%20performance%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-redeatitude&orientation=squarish",
    descricao: "Banda gospel com sons vibrantes e letras que falam à juventude cristã brasileira.",
    albuns: 5,
    musicas: 58,
    genero: "Pop Rock Gospel",
  },
  {
    id: "louvor-alianca",
    nome: "Louvor Aliança",
    imagem: "https://readdy.ai/api/search-image?query=Louvor%20Alianca%20brazilian%20gospel%20worship%20group%20band%20performance%20concert%20stage%20professional%20photo&width=400&height=400&seq=godoy-louvoralianca&orientation=squarish",
    descricao: "Ministério de louvor com canções que se tornaram hinos em igrejas evangélicas de todo o Brasil.",
    albuns: 7,
    musicas: 82,
    genero: "Gospel/Adoração",
  },
  {
    id: "emerson-pinheiro",
    nome: "Emerson Pinheiro",
    imagem: "https://readdy.ai/api/search-image?query=Emerson%20Pinheiro%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-emerson&orientation=squarish",
    descricao: "Cantor e líder de adoração com hits como 'A Vitória é Nossa' e 'Faz Chover', com mais de 15 anos de ministério.",
    albuns: 9,
    musicas: 105,
    genero: "Gospel/Adoração",
  },
  {
    id: "mara-maravilha",
    nome: "Mara Maravilha",
    imagem: "https://readdy.ai/api/search-image?query=Mara%20Maravilha%20brazilian%20female%20gospel%20singer%20professional%20portrait%20warm%20lighting%20concert%20stage&width=400&height=400&seq=godoy-mara&orientation=squarish",
    descricao: "Cantora gospel e apresentadora, uma das vozes mais conhecidas do cenário cristão brasileiro.",
    albuns: 18,
    musicas: 220,
    genero: "Gospel/Adoração",
  },
  // Novos artistas - 53 para chegar a 100
  {
    id: "paulo-cesar-baruk",
    nome: "Paulo Cesar Baruk",
    imagem: "https://readdy.ai/api/search-image?query=Paulo%20Cesar%20Baruk%20brazilian%20male%20gospel%20singer%20pianist%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-baruk&orientation=squarish",
    descricao: "Cantor, pianista e produtor musical, referência da adoração com canções profundas como 'Baruk'.",
    albuns: 10,
    musicas: 120,
    genero: "Gospel/Adoração",
  },
  {
    id: "leandro-borges",
    nome: "Leandro Borges",
    imagem: "https://readdy.ai/api/search-image?query=Leandro%20Borges%20brazilian%20male%20gospel%20singer%20young%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-leandro&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel, conhecido por 'Identidade' e canções de profunda adoração.",
    albuns: 5,
    musicas: 62,
    genero: "Gospel/Adoração",
  },
  {
    id: "kemuel",
    nome: "Kemuel",
    imagem: "https://readdy.ai/api/search-image?query=Kemuel%20brazilian%20male%20gospel%20singer%20worship%20band%20group%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-kemuel&orientation=squarish",
    descricao: "Ministério de adoração conhecido por 'Santo Pra Sempre' e 'Faz Chover', com sons contemporâneos.",
    albuns: 6,
    musicas: 74,
    genero: "Gospel/Adoração",
  },
  {
    id: "vinicius-zulato",
    nome: "Vinicius Zulato",
    imagem: "https://readdy.ai/api/search-image?query=Vinicius%20Zulato%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-zulato&orientation=squarish",
    descricao: "Cantor e compositor conhecido por 'Filho Pródigo', trazendo uma mensagem de restauração e graça.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "anderson-capote",
    nome: "Anderson Capote",
    imagem: "https://readdy.ai/api/search-image?query=Anderson%20Capote%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-capote&orientation=squarish",
    descricao: "Cantor e adorador com hits como 'Deixa Arder', representando a nova geração do gospel brasileiro.",
    albuns: 5,
    musicas: 58,
    genero: "Gospel/Adoração",
  },
  {
    id: "eliane-silva",
    nome: "Eliane Silva",
    imagem: "https://readdy.ai/api/search-image?query=Eliane%20Silva%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting%20dark%20background&width=400&height=400&seq=godoy-eliane&orientation=squarish",
    descricao: "Cantora gospel conhecida por 'A Mensagem', com voz marcante e ministério de adoração.",
    albuns: 7,
    musicas: 88,
    genero: "Gospel/Adoração",
  },
  {
    id: "william-nascimento",
    nome: "William Nascimento",
    imagem: "https://readdy.ai/api/search-image?query=William%20Nascimento%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-william&orientation=squarish",
    descricao: "Cantor e compositor com canções de testemunho e adoração que tocam corações pelo Brasil.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "flavia-lins",
    nome: "Flávia Lins",
    imagem: "https://readdy.ai/api/search-image?query=Flavia%20Lins%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-flavia&orientation=squarish",
    descricao: "Cantora gospel com projetos como 'Justificados', representando a adoração feminina no Brasil.",
    albuns: 5,
    musicas: 60,
    genero: "Gospel/Adoração",
  },
  {
    id: "adhemar-de-campos",
    nome: "Adhemar de Campos",
    imagem: "https://readdy.ai/api/search-image?query=Adhemar%20de%20Campos%20brazilian%20male%20gospel%20singer%20veteran%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-adhemar&orientation=squarish",
    descricao: "Um dos maiores compositores do gospel brasileiro, com clássicos como 'Consagrado' e 'Deus Proverá'.",
    albuns: 20,
    musicas: 280,
    genero: "Gospel/Adoração",
  },
  {
    id: "asaph",
    nome: "Asaph",
    imagem: "https://readdy.ai/api/search-image?query=Asaph%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20dramatic%20lighting&width=400&height=400&seq=godoy-asaph&orientation=squarish",
    descricao: "Cantor e compositor conhecido por 'Levanta e Anda', trazendo mensagens de fé e superação.",
    albuns: 6,
    musicas: 70,
    genero: "Gospel/Adoração",
  },
  {
    id: "alda-celia",
    nome: "Alda Célia",
    imagem: "https://readdy.ai/api/search-image?query=Alda%20Celia%20brazilian%20female%20gospel%20singer%20veteran%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-alda&orientation=squarish",
    descricao: "Cantora gospel veterana com canções como 'Nova Jerusalém', marcando gerações na adoração.",
    albuns: 14,
    musicas: 185,
    genero: "Gospel/Adoração",
  },
  {
    id: "ronaldo-bezerra",
    nome: "Ronaldo Bezerra",
    imagem: "https://readdy.ai/api/search-image?query=Ronaldo%20Bezerra%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-ronaldo&orientation=squarish",
    descricao: "Cantor e compositor gospel com hits como 'Aliança', representando a adoração contemporânea.",
    albuns: 8,
    musicas: 95,
    genero: "Gospel/Adoração",
  },
  {
    id: "heloisa-rosa",
    nome: "Heloisa Rosa",
    imagem: "https://readdy.ai/api/search-image?query=Heloisa%20Rosa%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting%20dark%20background&width=400&height=400&seq=godoy-heloisa&orientation=squarish",
    descricao: "Cantora e compositora com voz marcante, conhecida por adoração profunda e canções proféticas.",
    albuns: 7,
    musicas: 82,
    genero: "Gospel/Adoração",
  },
  {
    id: "comunidade-de-nilopolis",
    nome: "Comunidade de Nilópolis",
    imagem: "https://readdy.ai/api/search-image?query=Comunidade%20de%20Nilopolis%20brazilian%20gospel%20choir%20worship%20group%20stage%20performance%20professional%20photo&width=400&height=400&seq=godoy-nilopolis&orientation=squarish",
    descricao: "Ministério de louvor conhecido por 'O Deus que Faz' e canções de adoração coletiva poderosa.",
    albuns: 9,
    musicas: 110,
    genero: "Gospel/Adoração",
  },
  {
    id: "quatro-por-um",
    nome: "Quatro por Um",
    imagem: "https://readdy.ai/api/search-image?query=Quatro%20por%20Um%20brazilian%20gospel%20band%20group%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-quatro&orientation=squarish",
    descricao: "Banda gospel que marcou época nos anos 2000 com hits como 'Vida Nova' e 'Eu Te Amo'.",
    albuns: 8,
    musicas: 98,
    genero: "Pop Rock Gospel",
  },
  {
    id: "david-quinlan",
    nome: "David Quinlan",
    imagem: "https://readdy.ai/api/search-image?query=David%20Quinlan%20irish%20brazilian%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-davidq&orientation=squarish",
    descricao: "Cantor de origem irlandesa, referência da adoração com 'Eu e a Minha Casa' e 'Sonda-me'.",
    albuns: 12,
    musicas: 145,
    genero: "Gospel/Adoração",
  },
  {
    id: "lauriete",
    nome: "Lauriete",
    imagem: "https://readdy.ai/api/search-image?query=Lauriete%20brazilian%20female%20gospel%20singer%20veteran%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-lauriete&orientation=squarish",
    descricao: "Cantora gospel veterana conhecida como 'A Diva da Adoração', com clássicos como 'Alma Vencedora'.",
    albuns: 18,
    musicas: 240,
    genero: "Gospel/Adoração",
  },
  {
    id: "elaine-martins",
    nome: "Elaine Martins",
    imagem: "https://readdy.ai/api/search-image?query=Elaine%20Martins%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-elaine&orientation=squarish",
    descricao: "Cantora gospel com hits como 'Santificado', representando a adoração contemporânea feminina.",
    albuns: 8,
    musicas: 96,
    genero: "Gospel/Adoração",
  },
  {
    id: "andreia-zanette",
    nome: "Andréia Zanette",
    imagem: "https://readdy.ai/api/search-image?query=Andreia%20Zanette%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-andreia&orientation=squarish",
    descricao: "Cantora e compositora gospel com canções de fé e adoração que marcaram igrejas brasileiras.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "rafaela-santos",
    nome: "Rafaela Santos",
    imagem: "https://readdy.ai/api/search-image?query=Rafaela%20Santos%20brazilian%20female%20gospel%20singer%20young%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-rafaela&orientation=squarish",
    descricao: "Cantora da nova geração gospel, conhecida por 'Eu Sou Livre' e mensagens de liberdade em Cristo.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "jonas-ribas",
    nome: "Jonas Ribas",
    imagem: "https://readdy.ai/api/search-image?query=Jonas%20Ribas%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-jonasribas&orientation=squarish",
    descricao: "Cantor e compositor com canções de adoração profunda e ministério consolidado no Brasil.",
    albuns: 7,
    musicas: 84,
    genero: "Gospel/Adoração",
  },
  {
    id: "rebanhao",
    nome: "Rebanhão",
    imagem: "https://readdy.ai/api/search-image?query=Rebanhao%20brazilian%20christian%20rock%20band%20group%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-rebanhao&orientation=squarish",
    descricao: "Pioneiros do rock gospel brasileiro desde os anos 80, com clássicos como 'Vem Me Buscar'.",
    albuns: 16,
    musicas: 210,
    genero: "Rock Gospel",
  },
  {
    id: "ana-lucia-camara",
    nome: "Ana Lúcia Câmara",
    imagem: "https://readdy.ai/api/search-image?query=Ana%20Lucia%20Camara%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-analucia&orientation=squarish",
    descricao: "Cantora gospel com canções de confiança e adoração, representando a mulher cristã na música.",
    albuns: 6,
    musicas: 75,
    genero: "Gospel/Adoração",
  },
  {
    id: "aline-gomes",
    nome: "Aline Gomes",
    imagem: "https://readdy.ai/api/search-image?query=Aline%20Gomes%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-alineg&orientation=squarish",
    descricao: "Cantora gospel com mensagens de fé e provisão como 'Deus Proverá'.",
    albuns: 5,
    musicas: 60,
    genero: "Gospel/Adoração",
  },
  {
    id: "filipe-lancaster",
    nome: "Filipe Lancaster",
    imagem: "https://readdy.ai/api/search-image?query=Filipe%20Lancaster%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-filipe&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel, conhecido por 'Ressignificar' e canções autorais.",
    albuns: 3,
    musicas: 36,
    genero: "Gospel/Adoração",
  },
  {
    id: "cristiana-araujo",
    nome: "Cristiana Araújo",
    imagem: "https://readdy.ai/api/search-image?query=Cristiana%20Araujo%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-cristiana&orientation=squarish",
    descricao: "Cantora gospel com canções de confiança em Deus e adoração profunda.",
    albuns: 5,
    musicas: 62,
    genero: "Gospel/Adoração",
  },
  {
    id: "joelma",
    nome: "Joelma",
    imagem: "https://readdy.ai/api/search-image?query=Joelma%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-joelma&orientation=squarish",
    descricao: "Cantora gospel conhecida por canções de adoração e fé que inspiram milhares de pessoas.",
    albuns: 6,
    musicas: 78,
    genero: "Gospel/Adoração",
  },
  {
    id: "missionarios",
    nome: "Missionários",
    imagem: "https://readdy.ai/api/search-image?query=Missionarios%20brazilian%20gospel%20band%20group%20musicians%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-missionarios&orientation=squarish",
    descricao: "Banda gospel com sons modernos e letras que falam à juventude cristã brasileira.",
    albuns: 7,
    musicas: 85,
    genero: "Pop Rock Gospel",
  },
  {
    id: "lucinho",
    nome: "Lucinho",
    imagem: "https://readdy.ai/api/search-image?query=Lucinho%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-lucinho&orientation=squarish",
    descricao: "Cantor e compositor com hits de adoração e vitória, com carreira consolidada no gospel.",
    albuns: 10,
    musicas: 120,
    genero: "Gospel/Adoração",
  },
  {
    id: "alex-gonzaga",
    nome: "Alex Gonzaga",
    imagem: "https://readdy.ai/api/search-image?query=Alex%20Gonzaga%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-alex&orientation=squarish",
    descricao: "Cantor e compositor com canções de esperança e um novo tempo na adoração brasileira.",
    albuns: 6,
    musicas: 74,
    genero: "Gospel/Adoração",
  },
  {
    id: "sheldon",
    nome: "Sheldon",
    imagem: "https://readdy.ai/api/search-image?query=Sheldon%20brazilian%20male%20gospel%20rapper%20hip%20hop%20artist%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-sheldon&orientation=squarish",
    descricao: "Cantor e rapper gospel com mensagens de fé e transformação através do hip hop cristão.",
    albuns: 5,
    musicas: 58,
    genero: "Gospel Rap",
  },
  {
    id: "tatiana-souza",
    nome: "Tatiana Souza",
    imagem: "https://readdy.ai/api/search-image?query=Tatiana%20Souza%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-tatiana&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração profunda e intimidade com Deus.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "renascer-praise",
    nome: "Renascer Praise",
    imagem: "https://readdy.ai/api/search-image?query=Renascer%20Praise%20brazilian%20gospel%20worship%20choir%20group%20stage%20performance%20concert%20professional%20photo&width=400&height=400&seq=godoy-renascer&orientation=squarish",
    descricao: "Ministério de louvor da Igreja Renascer em Cristo, com hinos que marcaram décadas no gospel.",
    albuns: 25,
    musicas: 320,
    genero: "Gospel/Adoração",
  },
  {
    id: "ministerio-kades",
    nome: "Ministério Kades",
    imagem: "https://readdy.ai/api/search-image?query=Ministerio%20Kades%20brazilian%20gospel%20worship%20band%20group%20performance%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-kades&orientation=squarish",
    descricao: "Ministério de adoração com sons contemporâneos e canções que se tornaram hinos em igrejas.",
    albuns: 5,
    musicas: 60,
    genero: "Gospel/Adoração",
  },
  {
    id: "thiago-brado",
    nome: "Thiago Brado",
    imagem: "https://readdy.ai/api/search-image?query=Thiago%20Brado%20brazilian%20male%20gospel%20singer%20songwriter%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-thiago&orientation=squarish",
    descricao: "Cantor e compositor conhecido por 'Serenata' e canções autorais com profunda espiritualidade.",
    albuns: 4,
    musicas: 46,
    genero: "Gospel/Adoração",
  },
  {
    id: "nani-azevedo",
    nome: "Nani Azevedo",
    imagem: "https://readdy.ai/api/search-image?query=Nani%20Azevedo%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-nani&orientation=squarish",
    descricao: "Cantora gospel com voz marcante e canções de adoração que marcaram o cenário cristão nacional.",
    albuns: 10,
    musicas: 125,
    genero: "Gospel/Adoração",
  },
  {
    id: "shirley-carvalhaes",
    nome: "Shirley Carvalhaes",
    imagem: "https://readdy.ai/api/search-image?query=Shirley%20Carvalhaes%20brazilian%20female%20gospel%20singer%20veteran%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-shirley&orientation=squarish",
    descricao: "Uma das grandes damas do gospel brasileiro, com clássicos que marcaram gerações de adoradores.",
    albuns: 15,
    musicas: 195,
    genero: "Gospel/Adoração",
  },
  {
    id: "mariana-valadao",
    nome: "Mariana Valadão",
    imagem: "https://readdy.ai/api/search-image?query=Mariana%20Valadao%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-mariana&orientation=squarish",
    descricao: "Cantora gospel da família Valadão, com canções de adoração profunda e intimidade com Deus.",
    albuns: 5,
    musicas: 62,
    genero: "Gospel/Adoração",
  },
  {
    id: "guilherme-kerr",
    nome: "Guilherme Kerr",
    imagem: "https://readdy.ai/api/search-image?query=Guilherme%20Kerr%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-kerr&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel com canções autorais e mensagens de fé.",
    albuns: 3,
    musicas: 38,
    genero: "Gospel/Adoração",
  },
  {
    id: "papy",
    nome: "Papy",
    imagem: "https://readdy.ai/api/search-image?query=Papy%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background%20warm%20lighting&width=400&height=400&seq=godoy-papy&orientation=squarish",
    descricao: "Cantor gospel com canções de adoração e celebração que animam igrejas pelo Brasil.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "midian-lima",
    nome: "Midian Lima",
    imagem: "https://readdy.ai/api/search-image?query=Midian%20Lima%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-midian&orientation=squarish",
    descricao: "Cantora gospel conhecida por 'Restituição' e canções de esperança e restauração.",
    albuns: 5,
    musicas: 60,
    genero: "Gospel/Adoração",
  },
  {
    id: "gisele-nascimento",
    nome: "Gisele Nascimento",
    imagem: "https://readdy.ai/api/search-image?query=Gisele%20Nascimento%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-gisele&orientation=squarish",
    descricao: "Cantora gospel com canções proféticas e de adoração que marcaram o cenário cristão.",
    albuns: 7,
    musicas: 88,
    genero: "Gospel/Adoração",
  },
  {
    id: "criancas-diante-do-trono",
    nome: "Crianças Diante do Trono",
    imagem: "https://readdy.ai/api/search-image?query=Children%20worship%20brazilian%20gospel%20kids%20choir%20group%20singing%20professional%20photo%20bright%20stage&width=400&height=400&seq=godoy-criancasdt&orientation=squarish",
    descricao: "Ministério de louvor infantil do Diante do Trono, ensinando adoração às novas gerações.",
    albuns: 12,
    musicas: 145,
    genero: "Gospel Infantil",
  },
  {
    id: "mateus-romeiro",
    nome: "Mateus Romeiro",
    imagem: "https://readdy.ai/api/search-image?query=Mateus%20Romeiro%20brazilian%20male%20gospel%20singer%20young%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-mateus&orientation=squarish",
    descricao: "Cantor e compositor da nova geração gospel com canções de adoração autorais.",
    albuns: 3,
    musicas: 36,
    genero: "Gospel/Adoração",
  },
  {
    id: "priscila-alcantara",
    nome: "Priscila Alcântara",
    imagem: "https://readdy.ai/api/search-image?query=Priscila%20Alcantara%20brazilian%20female%20gospel%20singer%20young%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-priscila&orientation=squarish",
    descricao: "Cantora e apresentadora infantojuvenil, referência do gospel para crianças e adolescentes.",
    albuns: 8,
    musicas: 95,
    genero: "Gospel Infantojuvenil",
  },
  {
    id: "celia-sakamoto",
    nome: "Célia Sakamoto",
    imagem: "https://readdy.ai/api/search-image?query=Celia%20Sakamoto%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-celia&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração profunda e ministério consolidado no Brasil.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "sarah-farias",
    nome: "Sarah Farias",
    imagem: "https://readdy.ai/api/search-image?query=Sarah%20Farias%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-sarahf&orientation=squarish",
    descricao: "Cantora gospel conhecida por 'Adorador' e canções de adoração que tocam corações.",
    albuns: 5,
    musicas: 60,
    genero: "Gospel/Adoração",
  },
  {
    id: "samuel-mariano",
    nome: "Samuel Mariano",
    imagem: "https://readdy.ai/api/search-image?query=Samuel%20Mariano%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-samuel&orientation=squarish",
    descricao: "Cantor e compositor com canções de adoração e celebração que marcaram o gospel brasileiro.",
    albuns: 8,
    musicas: 95,
    genero: "Gospel/Adoração",
  },
  {
    id: "rafa-ribeiro",
    nome: "Rafa Ribeiro",
    imagem: "https://readdy.ai/api/search-image?query=Rafa%20Ribeiro%20brazilian%20male%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-rafa&orientation=squarish",
    descricao: "Cantor gospel da nova geração com canções autorais e mensagens de fé contemporâneas.",
    albuns: 3,
    musicas: 36,
    genero: "Gospel/Adoração",
  },
  {
    id: "valesca-mayssa",
    nome: "Valesca Mayssa",
    imagem: "https://readdy.ai/api/search-image?query=Valesca%20Mayssa%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-valesca&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração e celebração que animam igrejas pelo Brasil.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "jamily",
    nome: "Jamily",
    imagem: "https://readdy.ai/api/search-image?query=Jamily%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-jamily&orientation=squarish",
    descricao: "Cantora gospel conhecida por canções de adoração que marcaram o cenário cristão nacional.",
    albuns: 8,
    musicas: 95,
    genero: "Gospel/Adoração",
  },
  {
    id: "pg",
    nome: "PG",
    imagem: "https://readdy.ai/api/search-image?query=PG%20brazilian%20male%20gospel%20rapper%20hip%20hop%20artist%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-pg&orientation=squarish",
    descricao: "Rapper gospel da nova geração com letras impactantes e batidas modernas no hip hop cristão.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel Rap",
  },
  {
    id: "ministerio-adoracao-e-vida",
    nome: "Ministério Adoração e Vida",
    imagem: "https://readdy.ai/api/search-image?query=Adoracao%20e%20Vida%20brazilian%20gospel%20worship%20band%20group%20performance%20concert%20stage%20professional%20photo&width=400&height=400&seq=godoy-adoracaovida&orientation=squarish",
    descricao: "Ministério de louvor com canções que se tornaram hinos de adoração em igrejas brasileiras.",
    albuns: 7,
    musicas: 85,
    genero: "Gospel/Adoração",
  },
  {
    id: "flordelis",
    nome: "Flordelis",
    imagem: "https://readdy.ai/api/search-image?query=Flordelis%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-flordelis&orientation=squarish",
    descricao: "Cantora gospel e pastora com canções de adoração que marcaram o cenário cristão brasileiro.",
    albuns: 10,
    musicas: 120,
    genero: "Gospel/Adoração",
  },
  {
    id: "luma-elpidio",
    nome: "Luma Elpídio",
    imagem: "https://readdy.ai/api/search-image?query=Luma%20Elpidio%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dramatic%20lighting&width=400&height=400&seq=godoy-luma&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração profunda e intimidade com Deus.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "elia-oliveira",
    nome: "Eliã Oliveira",
    imagem: "https://readdy.ai/api/search-image?query=Elia%20Oliveira%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-elia&orientation=squarish",
    descricao: "Cantora gospel com voz marcante e canções de adoração que inspiram milhares de pessoas.",
    albuns: 5,
    musicas: 62,
    genero: "Gospel/Adoração",
  },
  {
    id: "genaina",
    nome: "Genaina",
    imagem: "https://readdy.ai/api/search-image?query=Genaina%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20dark%20background&width=400&height=400&seq=godoy-genaina&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração e celebração que animam igrejas pelo Brasil.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
  {
    id: "ministerio-atos-29",
    nome: "Ministério Atos 29",
    imagem: "https://readdy.ai/api/search-image?query=Atos%2029%20brazilian%20gospel%20worship%20band%20group%20performance%20stage%20concert%20professional%20photo&width=400&height=400&seq=godoy-atos29&orientation=squarish",
    descricao: "Ministério de louvor com canções baseadas na palavra de Deus e adoração contemporânea.",
    albuns: 5,
    musicas: 58,
    genero: "Gospel/Adoração",
  },
  {
    id: "juliana-de-paula",
    nome: "Juliana de Paula",
    imagem: "https://readdy.ai/api/search-image?query=Juliana%20de%20Paula%20brazilian%20female%20gospel%20singer%20worship%20leader%20professional%20portrait%20warm%20lighting&width=400&height=400&seq=godoy-juliana&orientation=squarish",
    descricao: "Cantora gospel com canções de adoração profunda e ministério consolidado no Brasil.",
    albuns: 6,
    musicas: 72,
    genero: "Gospel/Adoração",
  },
  {
    id: "bethel-music-br",
    nome: "Bethel Music BR",
    imagem: "https://readdy.ai/api/search-image?query=Bethel%20Music%20brazilian%20gospel%20worship%20band%20group%20performance%20concert%20stage%20professional%20photo&width=400&height=400&seq=godoy-bethelbr&orientation=squarish",
    descricao: "Versão brasileira do movimento Bethel Music, trazendo adoração profunda e sons contemporâneos.",
    albuns: 4,
    musicas: 48,
    genero: "Gospel/Adoração",
  },
];